<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref, watch} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
import $ from "jquery";
import router from "@/router";

export default {
  name: "AdvertisingPage",
  components: {LoadingPage},
  setup() {
    let store = useStore()
    let loading = ref(false)
    let cat_id = useRoute().params.cat_id
    let dialog = ref({
      action: false,
      type: 'state',
    })

    let years = ref([])
    let today = new Date().toLocaleDateString('fa-IR-u-nu-latn');
    let parsedDate = new Date(today);
    let year = parsedDate.getFullYear();

    for (year; year >= 1340; year--) {
      years.value.push(year)
    }

    let dialog_filter = ref(false)

    let page = ref('advertising')

    let profile = FreeWorld.PinkMan(store.state.profile, 'de')

    let ads = ref([])
    let search = []
    let input_search = ref()
    let input_search_street = ref()

    let country = ref(FreeWorld.PinkMan(store.state.country, 'de'))
    let city = ref([])
    let street = []
    let search_street = ref([])

    let show_city = ref(profile.city)
    let show_street = ref(null)

    let check_filter = ref(false)

    let data = ref({
      adver_category_id: cat_id,
      state_id: null,
      city_id: null,
      street_id: null,
      year_from: null,
      year_to: null,
      km_from: null,
      km_to: null,
      radio: null,
    })

    if (store.state.filter.advertising !== null) {
      data.value = FreeWorld.PinkMan(store.state.filter.advertising, 'de')

      const countryItem = country.value.find(item => item.id === data.value.state_id);
      if (countryItem) {
        const cityItem = countryItem.city.find(item_city => item_city.id === data.value.city_id);

        if (cityItem) show_city.value = countryItem.name;
      }
    }

    watch(() => input_search.value, () => {
      ads.value = []
      search.forEach((item) => {
        if (item.title.includes(input_search.value)) ads.value.push(item)
      })
    })

    watch(() => input_search_street.value, () => {
      search_street.value = []
      street.forEach((item) => {
        if (item.name.includes(input_search_street.value)) search_street.value.push(item)
      })
    })

    function get_advertising(del) {

      if (del) {
        data.value = {
          adver_category_id: cat_id,
          state_id: null,
          city_id: null,
          street_id: null,
          year_from: null,
          year_to: null,
          km_from: null,
          km_to: null,
          radio: null,
        }
        show_street.value = null
      }

      let fields = ['state_id', 'city_id', 'street_id', 'year_from', 'year_to', 'km_from', 'km_to', 'radio'];

      let x = false
      fields.forEach(field => {
        if (data.value[field] === undefined || data.value[field] === null || (typeof data.value[field] === 'string' && data.value[field].length === 0) || (typeof data.value[field] === 'number' && data.value[field] === 0)) {
          delete data.value[field];
        }

        if (data.value[field]) {
          check_filter.value = true;
          x = true
        } else if (!data.value[field]) {
          if (!x) check_filter.value = false
        }
      });

      if (data.value.radio) {
        if (data.value.radio === 'cheapest') {
          data.value.cheapest = 1;
        } else if (data.value.radio === 'newest') {
          data.value.newest = 1;
        } else if (data.value.radio === 'bestseen') {
          data.value.bestseen = 1;
        }
      }

      check_filter.value ? store.commit('set_filter_advertising', data.value) : store.commit('set_filter_advertising', 'delete')


      loading.value = true
      FreeWorld.Heisenberg(data.value, 'show_adver', true).then((res) => {
        loading.value = false
        ads.value = res.data
        search = res.data
        page.value = 'advertising'

        data.value.state_id ? chang_item('state', data.value.state_id) : chang_item('state', profile.state_id)
        data.value.city_id ? chang_item('state', data.value.city_id) : chang_item('city', profile.city_id)
        if (data.value.street_id) chang_item('street', data.value.street_id)

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, () => {
          get_advertising(del)
        })
      })
    }

    get_advertising(false)

    function chang_item(type, id, show_dialog) {
      switch (type) {
        case 'state':
          country.value.forEach((item) => {
            if (item.id === id) {
              city.value = item.city
              if (show_dialog) {
                data.value.state_id = item.id
                data.value.city_id = null
                dialog.value.type = 'city'
              }
              return false
            }
          })
          break;

        case 'city':
          city.value.forEach((item) => {
            if (item.id === id) {
              street = item.street
              search_street.value = item.street
              show_city.value = item.name
              if (show_dialog) {
                data.value.city_id = item.id
                open_dialog('state')
                get_advertising(false)
              }
              return false
            }
          })
          break;

        case 'street':
          show_street.value = null
          search_street.value.forEach((item) => {
            if (item.id === id) {
              data.value.street_id = item.id
              show_street.value = item.name
              if (show_dialog) open_dialog('street')
              return false
            }
          })
          break;
      }
    }

    function open_dialog(type) {
      let div
      switch (type) {
        case 'street':
          div = $("#dialog_street")

          if (dialog_filter.value) {
            div.removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              dialog_filter.value = false
            }, 700)
          } else {
            div.removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog_filter.value = true
          }
          break;

        case 'state':
          div = $("#dialog")

          if (dialog.value.action) {
            div.removeClass('animate__fadeIn').addClass('animate__fadeOut')
            if (data.value.state_id === undefined || data.value.city_id === undefined || data.value.state_id === null || data.value.city_id === null) {
              data.value.city_id = null;
              data.value.state_id = null;
            }
            setTimeout(() => {
              dialog.value.action = false
              dialog.value.type = 'state'
            }, 700)
          } else {
            div.removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value.action = true
          }
          break;
      }
    }

    function seen_ads(item) {
      store.commit('set_advertising', item)
      router.push({name: 'DetailsAdvertising'})
    }

    store.commit('set_advertising', 'delete')

    return {
      loading,
      ads,
      input_search,
      dialog,
      chang_item,
      open_dialog,
      country,
      city,
      data,
      show_city,
      page,
      dialog_filter,
      years,
      search_street,
      input_search_street,
      show_street,
      get_advertising,
      check_filter,
      seen_ads,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div v-if="page === 'advertising'" id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div v-if="dialog.action" @click="open_dialog('state')" class="bg_dialog"></div>
    <div v-if="dialog.action" class="dialog px-3">
      <div id="dialog" class="animate__animated animate__fadeIn bg-white rounded-4 shadow-custom p-3">
        <div class="position-relative">
          <p class="font-4 text-color font-bold text-center">انتخاب استان و شهرستان</p>

          <img @click="open_dialog('state')" class="icon-size-3 position-absolute top-0 start-0"
               src="../assets/img/icon-closeBgColor.svg" alt="">
        </div>

        <hr>

        <div v-if="dialog.type === 'state'" class="animate__animated animate__fadeIn list-states px-5">
          <div v-for="item in country" :key="item.id" class="">
            <p @click="chang_item('state',item.id , true)" class="font-4 text-color text-center">{{ item.name }}</p>
            <hr>
          </div>
        </div>

        <div v-if="dialog.type === 'city'" class="list-states animate__animated animate__fadeIn px-5">
          <div v-for="item in city" :key="item.id" class="">
            <p @click="chang_item('city',item.id , true)" class="font-4 text-color text-center">{{ item.name }}</p>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">آگهی ها</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div style="top:-1rem"
           class="d-flex align-items-center justify-content-between mb-4 position-sticky max_width w-100 z-1">
        <div class="d-flex align-items-center justify-content-between rounded-pill shadow-custom bg-white p-3 w-80">
          <div class="d-flex align-items-center w-65 bg-white">
            <img class="icon-size-3" src="../assets/img/icon-search.svg" alt="">
            <input v-model="input_search" class="border-0 text-center font-5 w-100" type="text"
                   placeholder="جستجوی عنوان آگهی">
          </div>

          <div class="hr-vertical bg-color"></div>

          <div @click="open_dialog('state')" class="d-flex align-items-center justify-content-around w-30">
            <img class="icon-size-2 ms-2" src="../assets/img/icon-place.svg" alt="">

            <div class="overflow-hidden">
              <p class="font-5" :class="show_city.length > 10 ? 'txtoverflow':''">{{ show_city }}</p>
            </div>
          </div>
        </div>

        <div class="position-relative">
          <p v-if="check_filter" class="bg-danger p-2 rounded-pill position-absolute z-1"></p>
          <img @click="page = 'filter'" class="icon-size-6 icon_shadow" src="../assets/img/icon-setting.svg" alt="">
        </div>
      </div>

      <div v-if="ads.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in ads" :key="item.id" @click="seen_ads(item)"
           class="animate__animated animate__fadeIn bg-white shadow-custom p-2 d-flex justify-content-between rounded-4 mb-3">
        <div class="d-flex flex-column justify-content-around w-60">
          <div class="overflow-hidden">
            <p class="text-color font-bold font-4" :class="item.title.length >= 30 ? 'txtoverflow':''">{{item.title}}</p>
          </div>

          <p v-if="item.price > 0" class="font-5">{{ item.price.toLocaleString() }} تومان</p>
          <p v-else class="font-5">توافقی</p>

          <p class="font-6">{{ item.time }}</p>

          <div class="hr-dash"></div>

          <p class="font-5">{{ item.state }} - {{ item.city }}</p>
        </div>

        <div class="img-ads rounded-4 animated-background">
          <img class="img-ads rounded-4 img-cover" :src="item.pic1" alt="">
        </div>
      </div>
    </div>
  </div>

  <div v-if="page === 'filter'" id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div v-if="dialog_filter" @click="open_dialog('street')" class="bg_dialog"></div>
    <div v-if="dialog_filter" class="dialog px-3">
      <div id="dialog_street" class="animate__animated animate__fadeIn bg-white rounded-4 shadow-custom p-3">
        <div class="position-relative">
          <p class="font-4 text-color font-bold text-center">انتخاب استان و شهرستان</p>

          <img @click="open_dialog('street')" class="icon-size-3 position-absolute top-0 start-0"
               src="../assets/img/icon-closeBgColor.svg" alt="">
        </div>

        <hr>

        <input v-model="input_search_street" class="rounded-pill p-3 shadow-custom w-100 mb-4" type="text"
               placeholder="جستجو">

        <div class="list-states px-5">
          <div v-for="item in search_street" :key="item.id" class="">
            <p @click="chang_item('street' , item.id , true)" class="font-4 text-color text-center">{{ item.name }}</p>
            <hr>
          </div>
        </div>
      </div>
    </div>


    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img @click="page = 'advertising'" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">فیلتر ها</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div class="d-flex justify-content-end mb-3">
        <img @click="get_advertising(true)" class="icon-size-4" src="../assets/img/icon-bin.svg" alt="">
      </div>

      <div class="d-flex justify-content-between align-items-center p-3 rounded-pill shadow-custom mb-4">
        <p class="font-4 text-color">محله</p>

        <div @click="open_dialog('street')" class="d-flex align-items-center">
          <p v-if="show_street === null" class="font-4 text-color">انتخاب نشده</p>
          <p v-else class="font-4 text-color">{{ show_street }}</p>

          <img class="icon-size-0-5 me-3" src="../assets/img/icon-arrowBottom.svg" alt="">
        </div>
      </div>

      <div class="mb-4">
        <p class="font-4 text-color px-2 mb-2">سال ساخت</p>
        <div class="d-flex justify-content-between">
          <select v-model="data.year_from" class="shadow-custom p-3 rounded-pill w-45 text-center">
            <option :value="undefined" hidden>از</option>
            <option v-for="item in years" :key="item.index" :value="item">{{ item }}</option>
          </select>

          <select v-model="data.year_to" class="shadow-custom p-3 rounded-pill w-45 text-center">
            <option :value="undefined" hidden>تا</option>
            <option v-for="item in years" :key="item.index" :value="item">{{ item }}</option>
          </select>
        </div>
      </div>

      <div class="mb-4">
        <p class="font-4 text-color px-2 mb-2">کارکرد (کیلومتر)</p>
        <div class="d-flex justify-content-between">
          <input v-model="data.km_from" class="shadow-custom p-3 rounded-pill w-45 text-center" type="number"
                 placeholder="از">

          <input v-model="data.km_to" class="shadow-custom p-3 rounded-pill w-45 text-center" type="number"
                 placeholder="تا">
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center p-3 rounded-pill shadow-custom mb-3">
        <label for="most-visited" class="font-4 text-color w-90">بیشترین بازدید</label>

        <input v-model="data.radio" id="most-visited" value="bestseen" name="sort" type="radio">
      </div>

      <div class="d-flex justify-content-between align-items-center p-3 rounded-pill shadow-custom mb-3">
        <label for="newest" class="font-4 text-color w-90">جدید ترین</label>

        <input v-model="data.radio" id="newest" value="newest" name="sort" type="radio">
      </div>

      <div class="d-flex justify-content-between align-items-center p-3 rounded-pill shadow-custom ">
        <label for="most-expensive" class="font-4 text-color w-90">گرانترین</label>

        <input v-model="data.radio" id="most-expensive" value="cheapest" name="sort" type="radio">
      </div>

      <div class="d-flex justify-content-center mt-5">
        <p @click="get_advertising(false)"
           class="bg-color-liner shadow-custom rounded-pill text-center text-white w-35 font-bold p-3 font-4">اعمال</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.img-ads {
  width: 10rem;
  height: 10rem;
}

.hr-dash {
  width: 100%;
  height: .1rem;
  border-bottom: .1rem dashed #0335BE;
}

.list-states {
  max-height: 20rem;
  overflow-y: scroll;
}

select {
  -webkit-appearance: none; /* برای مرورگرهای وب‌کیت */
  -moz-appearance: none; /* برای مرورگرهای فایرفاکس */
  appearance: none;
}

</style>